import RatingProgressBar from '~/models/Product/RatingProgressBar'
import ProductRating from '~/models/Product/ProductRating'

export default (productRating: ProductRating): RatingProgressBar[] => {
    const ratingsItems = [] as RatingProgressBar[]
    const totalCount = productRating.totalReviews
    const stars = { 1: 'oneStars', 2: 'twoStars', 3: 'threeStars', 4: 'fourStars', 5: 'fiveStars' }

    for (let i = 5; i > 0; i--) {
        ratingsItems.push({
            name: i,
            // @ts-ignore
            progress: Math.round((productRating[stars[i]] * 100) / totalCount),
            // @ts-ignore
            count: `${productRating[stars[i]]}x`,
        })
    }

    return ratingsItems
}
